import { useState, useRef } from 'react';
import { useOnClickOutside } from 'usehooks-ts';
import cn from 'classnames';

import { ChevronDownIcon_24, ChevronUpIcon_24, SelectIcon_24 } from 'assets/icons';
import styles from './Dropdown.module.css';
import Input from '../Input';

interface DropdownProps<T> {
  options: T[];
  selectedOption?: T;
  onSelect: (option: T) => void;
  placeholder?: string;
  className?: string;
  size: 'large' | 'normal' | 'small';
  editable?: boolean;
}

function Dropdown<T>({
  options,
  placeholder,
  className,
  size,
  selectedOption,
  onSelect,
  editable = false,
}: DropdownProps<T>) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useOnClickOutside(ref, () => setIsOpen(false));

  const toggleIsOpen = () => setIsOpen(!isOpen);

  const onSelectOption = (option: T) => () => {
    !!onSelect && onSelect(option);
    setIsOpen(false);
  };
  return (
    <>
      <div className={cn(styles.dropdown, className)} ref={ref}>
        {editable ? (
          <Input />
        ) : (
          <div
            className={cn(
              styles.dropdown__header,
              styles[size],
              selectedOption
                ? styles.dropdown__header_selected
                : styles.dropdown__header_placeholder,
              isOpen && styles.dropdown_open,
            )}
            onClick={toggleIsOpen}
          >
            <>
              {selectedOption || placeholder || options[0]}
              {isOpen ? <ChevronUpIcon_24 /> : <ChevronDownIcon_24 />}
            </>
          </div>
        )}
        {isOpen && (
          <div className={styles['dropdown__listContainer_' + size]}>
            <ul className={styles.dropdown__list}>
              {options.map((option) => (
                <li
                  className={cn(
                    styles.dropdown__listItem,
                    styles[size],
                    option === selectedOption && styles.dropdown__listItem_selected,
                  )}
                  onClick={onSelectOption(option)}
                  key={option as any}
                >
                  <>
                    {option} {option === selectedOption && <SelectIcon_24 />}
                  </>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </>
  );
}

export default Dropdown;
